/**
 * "Ver como": com qual papel o app se mostra quando nao ha login para dizer
 * (dados ficticios ou previa sem login). Avaliador cadastra e coleta; dono do
 * haras so consulta o plantel. Com login e dados reais, vale o papel do login.
 *
 * Preferencia do aparelho (localStorage): e conveniencia, nao dado.
 */
const CHAVE = 'equiview.perfil';

export type Perfil = 'avaliador' | 'haras';

export function lerPerfil(): Perfil {
  try {
    return localStorage.getItem(CHAVE) === 'haras' ? 'haras' : 'avaliador';
  } catch {
    return 'avaliador';
  }
}

/** Troca e recarrega: a fonte de dados e criada uma vez, na abertura do app. */
export function trocarPerfil(perfil: Perfil) {
  try {
    localStorage.setItem(CHAVE, perfil);
  } catch {
    // Sem armazenamento, a troca nao persiste; o recarregamento volta ao padrao.
  }
  window.location.assign('/');
}
